angular
  .module('workflow')

  .factory('TaskLastDaysCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class TaskLastDaysCrud extends Crud {
        constructor() {
          super(
            null,
            '@@apiUrl' + '/tasks-lastdays' + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }
      return TaskLastDaysCrud;
    }
  ]);
